import { Loader } from 'https://cdn.pika.dev/google-maps'

console.log("Loading store locator...")

class StoreLocator extends HTMLElement {
    constructor() {
        super()

        this.key = this.getAttribute('data-key')
        this.filter = ''
        this.init()
    }

    async getStoresFromCSV() {
        this.stores = []

        try {
            let response = await fetch(this.getAttribute('data-csv-url'))
            let csvData = await response.text()

            const jsonData = await new Promise((resolve, reject) => {
                Papa.parse(csvData, {
                    header: true,
                    complete: (result) => resolve(result.data),
                    error: (error) => reject(new Error('Error al parsear el CSV: ' + error.message))
                })
            })

            this.stores = Array.from(jsonData).map((store) => {
                let parsedStore = {
                    name: store.store_name ?? '',
                    city: store.city ?? '',
                    address: store.address ?? '',
                    lat: store.latitude ?? '',
                    lng: store.longitude ?? '',
                    paymentMethods: store.payment_methods ?? '',
                    key: `${store.store_name?.toLowerCase().replace(/[^\w\s]/g, '').replace(/\s+/g, '-').trim()}-${store.latitude}-${store.longitude}` ?? '',
                    scheduleMessage: store.schedule_message ?? '',
                    mondaySchedule: store.monday_schedule ?? '',
                    tuesdaySchedule: store.tuesday_schedule ?? '',
                    wednesdaySchedule: store.wednesday_schedule ?? '',
                    thursdaySchedule: store.thursday_schedule ?? '',
                    fridaySchedule: store.friday_schedule ?? '',
                    saturdaySchedule: store.saturday_schedule ?? '',
                    sundaySchedule: store.sunday_schedule ?? '',
                    specialScheduleMessage: store.special_schedule_message ?? '',
                    dayOffDate: store.day_off_date ?? '',
                    dayOffTime: store.day_off_time ?? ''
                }

                return parsedStore
            })
        }catch(error) {
            console.log('Error al obtener el archivo CSV: ', error)
        }
    }

    async initGoogleMaps() {
        const loader = new Loader(this.key, { libraries: ['places'] })

        const google = await loader.load()
        this.mapInstance = new google.maps.Map(this.querySelector('#store-locator-map'), {
            center: { lat: -17.0382794, lng: -64.8752546 },
            zoom: 6,
            styles: [{
                stylers: [{
                    saturation: -100
                }]
            }],
            disableDefaultUI: true,
            zoomControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
        })

        this.markers = this.stores.map(store => {
            const marker = new google.maps.Marker({
                position: { lat: Number(store.lat), lng: Number(store.lng) },
                map: this.mapInstance,
                icon: { 
                    url: `${ isClosed(store) ? "https://cdn.shopify.com/s/files/1/0800/4134/5332/files/Modo_de_aislamiento_6c172f1c-638c-4f95-9489-7dd428ee3742.svg?v=1742398821" : "https://cdn.shopify.com/s/files/1/0800/4134/5332/files/Modo_de_aislamiento.svg?v=1742398816" }`,
                    scaledSize: new google.maps.Size(40, 52)
                }
            })

            marker.store = store

            marker.addListener('click', () => {
                this.selectStore(store)
            })

            return marker
        })
    }

    renderStoreList() {
        this.citySelector = this.querySelector('#StoreLocatorCitySelector')
        this.storeList = this.querySelector('#StoreLocatorStores')

        const cities = new Set(this.stores.map(store => store.city))
        cities.forEach((city, i) => {
            this.citySelector.insertAdjacentHTML('beforeend', `
                <input type="radio" id="StoreLocatorCity-${i}" name="StoreLocatorCity" value="${city}" class="hidden" />
                <label for="StoreLocatorCity-${i}">${city}</label>
            `)
        })

        this.stores.forEach(store => {

            let specialScheduleItem = `
                <div class="store-item--warning">
                    <div class="store-item__icon--warning">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00016 3.16659C5.05464 3.16659 2.66683 5.5544 2.66683 8.49992C2.66683 11.4454 5.05464 13.8333 8.00016 13.8333C10.9457 13.8333 13.3335 11.4454 13.3335 8.49992C13.3335 5.5544 10.9457 3.16659 8.00016 3.16659ZM1.3335 8.49992C1.3335 4.81802 4.31826 1.83325 8.00016 1.83325C11.6821 1.83325 14.6668 4.81802 14.6668 8.49992C14.6668 12.1818 11.6821 15.1666 8.00016 15.1666C4.31826 15.1666 1.3335 12.1818 1.3335 8.49992Z" fill="#D81A1B"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 11.1667C7 10.6145 7.44772 10.1667 8 10.1667H8.00667C8.55895 10.1667 9.00667 10.6145 9.00667 11.1667V11.1734C9.00667 11.7257 8.55895 12.1734 8.00667 12.1734H8C7.44772 12.1734 7 11.7257 7 11.1734V11.1667Z" fill="#D81A1B"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99984 9.16675C7.63165 9.16675 7.33317 8.86827 7.33317 8.50008L7.33317 5.83341C7.33317 5.46522 7.63165 5.16675 7.99984 5.16675C8.36803 5.16675 8.6665 5.46522 8.6665 5.83341L8.6665 8.50008C8.6665 8.86827 8.36803 9.16675 7.99984 9.16675Z" fill="#D81A1B"/>
                        </svg>
                    </div>

                    <div class="store-item__info">
                        <p>${ store.specialScheduleMessage }</p>
                    </div>
                </div>
            `

            let scheduleItem = `
                <div class="store-item">
                    <div class="store-item__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 2.66667C2 2.29848 2.29848 2 2.66667 2H13.3333C13.7015 2 14 2.29848 14 2.66667V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V2.66667ZM3.33333 3.33333V12C3.33333 12.3682 3.63181 12.6667 4 12.6667H12C12.3682 12.6667 12.6667 12.3682 12.6667 12V3.33333H3.33333Z" fill="black"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 5.33341C2 4.96522 2.29848 4.66675 2.66667 4.66675H13.3333C13.7015 4.66675 14 4.96522 14 5.33341C14 5.7016 13.7015 6.00008 13.3333 6.00008H2.66667C2.29848 6.00008 2 5.7016 2 5.33341Z" fill="black"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6667 1.33325C11.0349 1.33325 11.3333 1.63173 11.3333 1.99992V3.33325C11.3333 3.70144 11.0349 3.99992 10.6667 3.99992C10.2985 3.99992 10 3.70144 10 3.33325V1.99992C10 1.63173 10.2985 1.33325 10.6667 1.33325Z" fill="black"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.33317 1.33325C5.70136 1.33325 5.99984 1.63173 5.99984 1.99992V3.33325C5.99984 3.70144 5.70136 3.99992 5.33317 3.99992C4.96498 3.99992 4.6665 3.70144 4.6665 3.33325V1.99992C4.6665 1.63173 4.96498 1.33325 5.33317 1.33325Z" fill="black"/>
                        </svg>
                    </div>

                    <div class="store-item__info">
                        <p>
                            Días de atención
                            </br>
                            ${store.scheduleMessage.split(',').map(message => `<span>${message}</span>`).join('</br>')}
                        </p>
                    </div>
                </div>
            `

            let addressItem = `
                <div class="store-item">
                    <div class="store-item__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M11.2135 10.3232C10.9703 10.201 10.6739 10.2958 10.5468 10.5366C10.4294 10.7818 10.5265 11.0761 10.7668 11.2032C11.3535 11.5032 11.6868 11.8699 11.6868 12.2232C11.6868 12.9766 10.1135 13.8166 8.00683 13.8166C5.90016 13.8166 4.32016 12.9832 4.32016 12.2499C4.32016 11.9032 4.6535 11.5299 5.24016 11.2299C5.4161 11.1594 5.53701 10.9954 5.55243 10.8065C5.56784 10.6176 5.4751 10.4362 5.31292 10.338C5.15075 10.2399 4.94703 10.2419 4.78683 10.3432C3.97743 10.6483 3.41315 11.3886 3.3335 12.2499C3.3335 13.7299 5.3335 14.8432 8.00016 14.8432C10.6668 14.8432 12.6668 13.7299 12.6668 12.2499C12.5945 11.3811 12.029 10.6314 11.2135 10.3232Z" fill="black"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50016 12.5432V9.66324C5.30476 9.39873 3.69518 7.47011 3.82767 5.2628C3.96016 3.05549 5.78888 1.33325 8.00016 1.33325C10.2114 1.33325 12.0402 3.05549 12.1727 5.2628C12.3051 7.47011 10.6956 9.39873 8.50016 9.66324V12.5432C8.50016 12.8194 8.27631 13.0432 8.00016 13.0432C7.72402 13.0432 7.50016 12.8194 7.50016 12.5432ZM10.9496 4.29401C10.4547 3.10263 9.29026 2.32721 8.00016 2.32991C6.24542 2.33357 4.82383 3.75516 4.82016 5.50991C4.81747 6.8 5.59288 7.96444 6.78426 8.45939C7.97564 8.95433 9.3479 8.68212 10.2601 7.76988C11.1724 6.85764 11.4446 5.48538 10.9496 4.29401Z" fill="black"/>
                            <path d="M6.3935 6.24991C6.66964 6.24991 6.8935 6.02605 6.8935 5.74991C6.8935 4.98407 7.51433 4.36324 8.28016 4.36324C8.55631 4.36324 8.78016 4.13938 8.78016 3.86324C8.78016 3.5871 8.55631 3.36324 8.28016 3.36324C7.64541 3.36501 7.03736 3.61885 6.58977 4.06894C6.14218 4.51903 5.89173 5.12849 5.8935 5.76324C5.89525 5.89408 5.94892 6.01887 6.04269 6.11014C6.13646 6.20141 6.26265 6.25169 6.3935 6.24991Z" fill="black"/>
                        </svg>
                    </div>

                    <div class="store-item__info">
                        <p>
                            Dirección
                            <br/>
                            <span>${store.address}</span>
                        </p>
                    </div>
                </div>
            `

            let paymentMethodsItem = `
                <div class="store-item">
                    <div class="store-item__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.3335 3.33341C1.3335 2.96522 1.63197 2.66675 2.00016 2.66675H14.0002C14.3684 2.66675 14.6668 2.96522 14.6668 3.33341V11.3334C14.6668 12.438 13.7714 13.3334 12.6668 13.3334H3.3335C2.22893 13.3334 1.3335 12.438 1.3335 11.3334V3.33341ZM2.66683 6.66675V11.3334C2.66683 11.7016 2.96531 12.0001 3.3335 12.0001H12.6668C13.035 12.0001 13.3335 11.7016 13.3335 11.3334V6.66675H2.66683ZM13.3335 5.33341H2.66683V4.00008H13.3335V5.33341Z" fill="black"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4 8.66667C4 8.29848 4.29848 8 4.66667 8H6.66667C7.03486 8 7.33333 8.29848 7.33333 8.66667C7.33333 9.03486 7.03486 9.33333 6.66667 9.33333H4.66667C4.29848 9.33333 4 9.03486 4 8.66667Z" fill="black"/>
                        </svg>
                    </div>

                    <div class="store-item__info">
                        <p>
                            Métodos de Pago
                            <br/>
                            <span>${store.paymentMethods}</span>
                        </p>
                    </div>
                </div>
            `

            this.storeList.insertAdjacentHTML('beforeend', `
                <div class="store-locator__store" data-city="${store.city}" data-key=${store.key}>
                    <div class="store-locator__store-title">
                        <svg class="back" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M20.05 11.47L13.05 4.47C12.8571 4.28243 12.5787 4.21204 12.3198 4.28533C12.0609 4.35863 11.8608 4.56447 11.7948 4.82533C11.7289 5.08619 11.8071 5.36243 12 5.55L17.71 11.25H4.47998C4.06577 11.25 3.72998 11.5858 3.72998 12C3.72998 12.4142 4.06577 12.75 4.47998 12.75H17.7L12 18.45C11.857 18.5893 11.7764 18.7804 11.7764 18.98C11.7764 19.1796 11.857 19.3707 12 19.51C12.1378 19.6546 12.3302 19.7345 12.53 19.73C12.729 19.7309 12.9201 19.6516 13.06 19.51L20.06 12.51C20.3524 12.2172 20.3524 11.7428 20.06 11.45L20.05 11.47Z" fill="black"/>
                        </svg>

                        <h4>
                            ${store.name}
                        </h4>

                        <svg class="view" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M20.05 11.47L13.05 4.47C12.8571 4.28243 12.5787 4.21204 12.3198 4.28533C12.0609 4.35863 11.8608 4.56447 11.7948 4.82533C11.7289 5.08619 11.8071 5.36243 12 5.55L17.71 11.25H4.47998C4.06577 11.25 3.72998 11.5858 3.72998 12C3.72998 12.4142 4.06577 12.75 4.47998 12.75H17.7L12 18.45C11.857 18.5893 11.7764 18.7804 11.7764 18.98C11.7764 19.1796 11.857 19.3707 12 19.51C12.1378 19.6546 12.3302 19.7345 12.53 19.73C12.729 19.7309 12.9201 19.6516 13.06 19.51L20.06 12.51C20.3524 12.2172 20.3524 11.7428 20.06 11.45L20.05 11.47Z" fill="black"/>
                        </svg>
                    </div>

                    <div class="store-locator__store-status ${ isClosed(store) ? 'closed' : '' }">
                        <div class="store-locator__store-status-icon"><span></span></div>
                        <span class="store-locator__store-status-label">${ isClosed(store) ? 'Cerrado' : 'Abierto' }</span>
                    </div>

                    ${ !!store.specialScheduleMessage ? specialScheduleItem : ''}
                    ${ !!store.scheduleMessage ? scheduleItem : ''}
                    ${ !!store.address ? addressItem : ''}
                    ${ !!store.paymentMethods ? paymentMethodsItem : ''}
                </div>
            `)
        })
    }

    updateMapPosition(latLng, zoom = 15) {
        this.mapInstance.setOptions({ center: latLng, zoom: zoom })
    }

    selectStore(selectedStore) {
        Array.from(this.storeList.children).forEach(store => {
            if(selectedStore.key === store.dataset.key) {
                store.classList.remove('hidden')
                store.classList.add('active')

            }else {
                store.classList.add('hidden')
            }
        })

        this.updateMapPosition({ lat: Number(selectedStore.lat), lng: Number(selectedStore.lng) })
    }

    setListeners() {
        this.citySelector.addEventListener("change", (event) => {
            this.filter = event.target.value
            this.citySelector.parentElement.querySelector('summary span').innerText = !!this.filter ? this.filter : 'Ciudad'

            let firstCityStore = this.stores.find(store => store.city === this.filter)
            if(!!firstCityStore) {
                this.updateMapPosition({ lat: Number(firstCityStore.lat), lng: Number(firstCityStore.lng) }, 11)
            
            }else {
                this.mapInstance.setOptions({ zoom: 6 })
            }

            Array.from(this.storeList.children).forEach(store => {
                store.classList.toggle('hidden', !!this.filter && store.hasAttribute('data-city') && store.dataset.city !== this.filter)
            })

            if(!!this.filter) history.pushState(null, "", `?city=${this.filter.toLocaleLowerCase().replace(/\s+/g, '-')}`)
            else history.pushState(null, "", location.pathname)
        })

        Array.from(this.storeList.children).forEach(store => {
            store.addEventListener('click', event => {
                if(!!!event.target.closest(".store-locator__store-title")) return

                if(store.classList.contains('active')) {
                    store.classList.remove('active')
                    this.storeList.children[0].classList.remove('hidden')
                    Array.from(this.storeList.children).forEach(storeElement => {
                        storeElement.classList.toggle('hidden', !!this.filter && storeElement.hasAttribute('data-city') && storeElement.dataset.city !== this.filter)
                    })
                    this.mapInstance.setOptions({ zoom: 6 })

                }else {
                    const selectedStore = this.stores.find(storeObject => storeObject.key === store.dataset.key)
                    if(!!selectedStore) {
                        this.selectStore(selectedStore)
                    }
                }
            })
        })

        if(!!location.search) {
            this.citySelector.querySelectorAll('[name="StoreLocatorCity"]')?.forEach(input => {
                if(input.value.toLowerCase().replace(/\s+/g, '-') === location.search.split('=')[1]) {
                    console.log(input.nextElementSibling)
                    input.nextElementSibling.click()
                }
            })
        }
    }
    
    async init() {
        await this.getStoresFromCSV()
        await this.initGoogleMaps()
        this.renderStoreList()
        this.setListeners()
    }
}
customElements.define('store-locator', StoreLocator)

function getClosed(schedule) {
    if(!!schedule) {
        let [openHour, closeHour] = schedule.split('-')
        let currentHour = new Date().getHours()
        let currentMinute = new Date().getMinutes()

        let openHourPart = 0
        let openMinutePart = 0
        let closeHourPart = 0
        let closeMinutePart = 0

        if (openHour.includes(':') || closeHour.includes(':')) {
            if(openHour.includes(':')) {
                [openHourPart, openMinutePart] = openHour.split(':').map(Number)
            }else {
                openHourPart = Number(openHour)
            }
    
            if(closeHour.includes(':')) {
                [closeHourPart, closeMinutePart] = closeHour.split(':').map(Number)
            }else {
                closeHourPart = Number(closeHour)
            }

            return (currentHour < openHourPart || (currentHour === openHourPart && currentMinute < openMinutePart) || currentHour > closeHourPart || (currentHour === closeHourPart && currentMinute >= closeMinutePart)) 
        }

        return currentHour < Number(openHour) || currentHour >= Number(closeHour)
    }

    return true
}

function isClosed(store) {
    let isClosed = false

    let today = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase()
    switch (today) {
        case 'monday':
            isClosed = getClosed(store.mondaySchedule)
            break;
        case 'tuesday':
            isClosed = getClosed(store.tuesdaySchedule)
            break;
        case 'wednesday':
            isClosed = getClosed(store.wednesdaySchedule)
            break;
        case 'thursday':
            isClosed = getClosed(store.thursdaySchedule)
            break;
        case 'friday':
            isClosed = getClosed(store.fridaySchedule)
            break;
        case 'saturday':
            isClosed = getClosed(store.saturdaySchedule)
            break;
        case 'sunday':
            isClosed = getClosed(store.sundaySchedule)
            break;
    }

    if(!!store.dayOffDate) {
        store.dayOffDate.split(',').forEach(dayOff => {
            let [day, month, year] = dayOff.split('/')
            let dayOffDate = new Date(`${month}/${day}/${year}`)

            if (dayOffDate.toDateString() === new Date().toDateString()) {
                isClosed = getClosed(store.dayOffTime)
            }
        })
    }

    return isClosed
}